import { Injectable } from "@angular/core";
@Injectable()
export class BarcodeOptions {
    public options = {
        showFlipCameraButton: true, // iOS and Android
        showTorchButton: true, // iOS and Android
        saveHistory: true, // Android, save scan history (default false)
        prompt: 'Place a barcode inside the scan area', // Android
        resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
        disableAnimations: true, // iOS
        disableSuccessBeep: false // iOS and Android
    };
}
